import { UpdateSearchConditionsApi } from "@/features/accounts/shared/services/update-search-conditions-api";
import { UpdateSearchConditionsPutRequestModel } from "@/features/accounts/shared/services/update-search-conditions-model";

/// 検索条件更新処理
export class UpdateSearchConditionsService {
  private updateSearchConditionsApi = new UpdateSearchConditionsApi();

  /**
   * 検索条件更新API実行
   */
  public async updateSearchConditions(param: UpdateSearchConditionsPutRequestModel) {
    return await this.updateSearchConditionsApi.updateSearchConditions(param);
  }
}
